<template>
    <div>
        <v-btn bottom color="#00b0f6" dark fab fixed right @click="dialog = !dialog">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" width="800px">
            <v-card>
                <v-card-title class=" darken-2">
                    Nuevo Usuario
                </v-card-title>
                <v-container>
                    <v-row class="mx-2">
                        <v-col cols="5">
                            <v-text-field prepend-icon="mdi-domain" placeholder="Nombre Fiscal" v-model="fiscalName" />
                        </v-col>
                        <v-col cols="5">
                            <v-text-field prepend-icon="mdi-account" placeholder="Nombre Social" v-model="socialName" />
                        </v-col>
                        <v-col cols="2">
                            <v-checkbox v-model="checkbox" label="IRPF"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field prepend-icon="mdi-credit-card" placeholder="CIF/NIF" v-model="cif" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field prepend-icon="mdi-mail" placeholder="Email" v-model="email" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field prepend-icon="mdi-home" placeholder="Dirección" v-model="address" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field prepend-icon="mdi-home" placeholder="Población" v-model="town" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field prepend-icon="mdi-home" placeholder="Provincia" v-model="province" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field prepend-icon="mdi-home" placeholder="Código Postal" v-model="postalCode" />
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-btn class="modalBT" v-on:click="createClient" small color="#00b0f6">Guardar</v-btn>
                    <v-btn class="modalBT" @click="dialog = false" small color="#FF0000">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "createPartnerForm",
    props: ['getData'],
    data() {
        return {
            checkbox: 1,
            dialog: false,
            fiscalName: '',
            socialName: '',
            cif: '',
            email: '',
            address: '',
            town: '',
            province: '',
            postalCode: ''
        }
    },
    methods: {
        createClient() {
            let url = this.base_url + '/invV2/admin/setClient.php';
            let formData = new FormData();
            formData.set('token', localStorage.token);
            formData.set('fiscalName', this.fiscalName);
            formData.set('socialName', this.socialName);
            formData.set('CIF', this.cif);
            formData.set('email', this.email);
            formData.set('address', this.address);
            formData.set('town', this.town);
            formData.set('province', this.province);
            formData.set('postalCode', this.postalCode);
            formData.set('irpf', this.checkbox)
            this.axios.post(url, formData).then(() => {
                this.getData();
                this.dialog = false;
            });
        }
    }
}
</script>

<style scoped></style>